export const TOOLTIP_CLASSNAME = 'tooltip';
